import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	tryItFreeButtonLabel: {
		id: 'servicedesk-premium-landing-page.try-it-free-button-label',
		defaultMessage: 'Try it free',
		description: 'Label for the try it free button in the Premium landing page.',
	},
	errorFlagTitle: {
		id: 'servicedesk-premium-landing-page.error-flag-title',
		defaultMessage: "We're not sure what went wrong",
		description: 'Title for the error flag when opening the billing page fails',
	},
	errorFlagDescription: {
		id: 'servicedesk-premium-landing-page.error-flag-description',
		defaultMessage: 'Try refreshing the page. If this keeps happening, contact support.',
		description: 'Description for the error flag when opening the billing page fails',
	},
});
